import { Container } from "@mui/material";
import { BackButton } from "~/components/common/navigation";
import { Stack } from "~/components/ui/stack";
import { AddActivationForm } from "./components";

export const AddActivationPage = () => {
  return (
    <Container maxWidth="sm">
      <Stack gap="xlarge">
        <BackButton />
        <AddActivationForm />
      </Stack>
    </Container>
  );
};
